<template>
  <SingleCard>
    <template #title>
      Reset password
    </template>
    <template #body>
      <ValidationObserver ref="form" slim>
        <VForm>
          <VLayout row>
            <TextFieldWithValidation
              v-model="email"
              rules="required|email"
              label="Enter your email"
              name="email"
              autocomplete="email"
              type="email"
              @keyup.enter="reset"
            />
          </VLayout>
        </VForm>
      </ValidationObserver>
    </template>
    <template #actions>
      <VLayout wrap justify-space-between pa-2>
        <VBtn
          :disabled="submitting"
          :loading="submitting"
          color="#4D5CD9"
          ripple
          block
          dark
          width="180"
          height="60"
          @click="reset"
        >
          Send reset password email
        </VBtn>
      </VLayout>
    </template>
    <template #under-card>
      <nuxt-link :to="{ name: 'auth-create' }"
        >Create customer account</nuxt-link
      >
    </template>
  </SingleCard>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import SingleCard from '~/components/base/SingleCard'
import TextFieldWithValidation from '~/components/TextFieldWithValidation'

export default {
  name: 'ResetForm',
  components: {
    SingleCard,
    TextFieldWithValidation,
    ValidationObserver
  },
  data: () => ({
    email: '',
    submitting: false
  }),
  methods: {
    async reset() {
      try {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          // eslint-disable-next-line no-console
          this.$nuxt.$loading.start()
          try {
            console.log('send')
          } catch (error) {
            console.log('Login error:', error)
          } finally {
            this.$nuxt.$loading.finish()
          }
        }
      } catch (error) {
        console.log('Validation error:', error)
      }
    }
  }
}
</script>
